import { svgstore } from '../lib/svgstore'

// link
for (const el of document.querySelectorAll('.vp-block-hero-homepage .link a')) {
    el.innerHTML += svgstore('arrow-button')
}
